import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { Router, ActivationEnd, RouterEvent } from '@angular/router';

import { environment } from '../environments/environment';
import { ErrorHandler, HandleError } from './services/error-handler.service';
import { NavigationService } from './services/navigation.service';

import { UserInfo } from './models/user';
import { QuickPayInfo } from './models/quickpay';
import { NavigationOptions } from './models/navigation';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  private _handleError: HandleError;
  private _logging = environment.logging;

  title = 'AccountVue';

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  isNavigationTwoRows = false;

  userInfo: UserInfo;
  quickpayInfo: QuickPayInfo;

  // Are we in maintenance mode?
  isInMaintenanceMode = environment.isInMaintenanceMode;

  constructor(
    private _router: Router,
    private _errorHandler: ErrorHandler,
    private _navigationService: NavigationService,
    public media: MediaObserver
  ) {
    this._handleError = _errorHandler.createHandleError('AppComponent');

    // Cannot use ActivatedRoute.data.subscribe() because the app component is outside the <router-outlet>
    // Must use Router.events.subscribe() instead
    this._router.events.subscribe((e: RouterEvent) => {
      if (e instanceof ActivationEnd) {
        if (e.snapshot.routeConfig !== undefined && e.snapshot.routeConfig !== null && e.snapshot.routeConfig.path !== undefined) {
          this.isNavigationTwoRows = this._navigationService.isNavigationTwoRows(e.snapshot.routeConfig.path.toLowerCase());
        } else {
          this.isNavigationTwoRows = this._navigationService.isNavigationTwoRows();
        }
      }
    });
  }

  ngOnInit() {}
}
